import * as messageBus from '@wh/message-bus';
import { PUSH_COMPONENT_READY } from '@push-component/constants';
import getClient from './src/client';

function operationSelector(operationName) {
  return window.subscriptionManager[operationName];
}

var client = getClient({
  messageBus: messageBus,
  operationSelector: operationSelector,
  readyTopic: PUSH_COMPONENT_READY
});
/* eslint-disable prefer-destructuring */

export var subscribe = client.subscribe;
export var unsubscribe = client.unsubscribe;
export var unsubscribeAll = client.unsubscribeAll;
/* eslint-enable prefer-destructuring */